import React, { useState, useEffect, useMemo } from "react";
import { SlIcon } from "@shoelace-style/shoelace/dist/react";
import config from "../../config";
import api from "../../services/api";
import NoDataFound from '../../shared/NoDataFound';
import ScrollContainer from "react-indiana-drag-scroll";
import Paginator from '../../shared/Paginator';
import { useTableState } from "./utils/useTableState";
import { alphaformatDateTime } from "../../utils/dateFormat";
import TableLoader from "../../shared/TableLoader";
import FilterBar from './components/FilterBar';
import ContentDrawer from "./components/ContentDrawer";

 const types = [
  {
    value: "all",
    label: "All",
  },
  {
    value: "full_page",
    label: "Full Image",
  },
  {
    value: "full_video",
    label: "Full Video",
  },
  {
      value:"half_video",
      label:"Half Video"
  },
  {
    value: "promoted_image_story",
    label: "Promoted Image Story ",
  },
  {
    value:"promoted_video_story",
    label:"Promoted Video Story"
  },
  {
    value: "classifiedads",
    label: "Classified Ads"
  }
]
const STATUS_OPTIONS = [
  { value: 2, label: 'Saved' },
  { value: 3, label: 'Picked' },
  { value: 4, label: 'Completed' },
  { value: 5, label: 'Rejected' },
  { value: 6, label: 'Accepted' },
];

const ReadyToLiveAds = () => {
  const [readyAds, setReadyAds] = useState([]);
  const [totalPages, settotalPages] = useState(0);
  const [loader, setloader] = useState(false);
  const { currentPage, setCurrentPage, handlePageClick } = useTableState();
  const [designers, setDesigners] = useState([]);
  const [showAdDetails, setShowAdDetails] = useState(false);
  const [rowData,setRowData]=useState({})
  // Filter state
  const [dateRange, setDateRange] = useState({ startDate: '', endDate: '' });
  const [designer, setDesigner] = useState(null);
  const [status, setStatus] = useState(null);
  const [adType, setAdType] = useState(null);
  const [search, setSearch] = useState('');

  // Designer options for react-select
  const designerOptions = useMemo(() =>
    designers.map(d => ({ value: d.designer_id, label: d.name })),
    [designers]
  );

  // Fetch designers on mount
  useEffect(() => {
    const fetchDesigners = async () => {
      try {
        let res = await api({
          url: `/alpha_cst_designer/getDesigners`,
          method: "POST",
          responseType: "json",
          data: {}
        });
        if (res.code === 200)
          setDesigners(res.data?.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchDesigners();
    setCurrentPage(0);
  }, []);

  // Fetch ads on filter or page change
  useEffect(() => {
    FetchReadyToLive(currentPage);
  }, [currentPage, dateRange, designer, status, adType, search]);

  const FetchReadyToLive = async (page) => {
    try {
      setloader(true);
      let res = await api({
        url: `/alpha_cst_designer/getReadytoLiveAds`,
        method: "POST",
        responseType: "json",
        data: {
          page,
          limit: config.PER_PAGE,
          startDate: dateRange.startDate,
          endDate: dateRange.endDate,
          designerId: designer ? designer.value : null,
          status: status ? status.value : null,
          adType: adType && adType.value !== 'all' ? adType.value : null,
          search: search || null,
        }
      });
      if (res.code === 200) {
        setReadyAds(res.data?.data);
        settotalPages(Math.ceil(res.data?.total / 10));
      }
      setloader(false)
    } catch (error) {
      setloader(false);
      console.error(error);
    }
  }

  const checkpayment = async (creative_id, latest_design, status) => {
    try {
      let res = await api({
        url: `/alpha_cst_designer/pickcompletedAd`,
        method: "POST",
        responseType: "json",
        data: {
          creative_id,
          latest_design,
          status
        }
      });
      if (res.code === 200) {
        FetchReadyToLive(currentPage);
      }
    }
    catch (error) {
      console.error(error);
    }
  }

  // Handlers
  const handleDateChange = (val) => setDateRange(val);
  const handleDesignerChangeSelect = (val) => setDesigner(val);
  const handleStatusChange = (val) => setStatus(val);
  const handleAdTypeChange = (val) => setAdType(val);
  const handleSearchChange = (e) => setSearch(e.target.value);

  return (
    <div>
      <FilterBar
        dateRange={dateRange}
        onDateChange={handleDateChange}
        designer={designer}
        onDesignerChange={handleDesignerChangeSelect}
        designerOptions={designerOptions}
        status={status}
        onStatusChange={handleStatusChange}
        statusOptions={STATUS_OPTIONS}
        showDesigner={false}
        showStatus={false}
        adType={adType}
        onAdTypeChange={handleAdTypeChange}
        adTypeOptions={types}
        showAdType={true}
        search={search}
        onSearchChange={(val) => setSearch(val)}
        showSearch={true}
      />
      <ScrollContainer>
        <table className="table table-bordered">
          <thead>
            <tr className="bg-gray-100">
              <th className="p-2 text-left">Sales Person Details</th>
              <th>Ad Creation Date</th>
              <th>Brand</th>
              <th>Client</th>
              <th>Campaign Name</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Ad Type</th>
              <th>Ad Creative</th>
              <th>Action</th>
              <th>Ad Details</th>
            </tr>
          </thead>
          {readyAds.length > 0 && !loader ? (
            readyAds.map((row, idx) => {
              const created_at = alphaformatDateTime(row.created_at);
              const start_date = alphaformatDateTime(row.creative_start_date);
              const end_date = alphaformatDateTime(row.creative_end_date);
              console.log(row, start_date);
              return (
                <tbody key={row.creative_id}>
                  <tr className="border-t">
                    <td className="p-2">
                      <div className="flex items-center gap-1">
                        <sl-icon name="person" />
                        <span>{row.name}</span>
                      </div>
                      <div className="text-xs text-gray-500 flex items-center gap-1">
                        <sl-icon name="telephone" />
                        <span>{row.mobile}</span>
                      </div>
                    </td>

                    <td>
                      <div>{created_at.dateStr}</div>
                      <div className="text-xs text-gray-500">{created_at.timeStr}</div>
                    </td>
                    <td>{row.brand_name}</td>
                    <td>{row.client_name}</td>
                    <td>{row.creative_name}</td>
                    <td>
                      <div className="font-bold">{start_date.dateStr}</div>
                      <div className="text-xs text-gray-500 font-bold">{start_date.timeStr}</div>
                    </td>
                    <td>
                      <div className="font-bold">{end_date.dateStr}</div>
                      <div className="text-xs text-gray-500 font-bold">{end_date.timeStr}</div>
                    </td>
                    <td>{row.ad_creative_sub_type}</td>
                    <td>{row.type}</td>
                    <td>
                      <button
                        className="bg-blue-600 text-white px-3 py-1 rounded"
                        onClick={() => {
                          checkpayment(row.creative_id, row.latest_design, row.status);
                        }}
                      >
                        Pick Ad
                      </button>
                    </td>
                     <td>
                      <button className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700" onClick={()=>{setRowData(row); setShowAdDetails(true)}}>View Ad Details</button>
                    </td>
                  </tr>
                </tbody>
              );
            })
          ) : !readyAds?.length && !loader ? (
            <NoDataFound colspan="15" />
          ) : (
            <TableLoader colspan="15" />
          )}
        </table>
      </ScrollContainer>
      <div className="flex justify-end">{totalPages > 1 && <Paginator pageCount={totalPages} handlePageClick={handlePageClick} forcePage={currentPage} />}</div>
      <ContentDrawer isOpen={showAdDetails} type="adDetails" rowData={rowData} onClose={() => setShowAdDetails(!showAdDetails)} />
    </div>
  );
};

export default ReadyToLiveAds;
